import { AppRouteConfig, breadcrumbs } from '..';

export enum PaymentRouteName {
	payment = 'Payment',
	allPaymentList = 'AllPaymentList',
	AddManualPayment = 'AddManualPayment',
	allTransactionList = 'AllTransactionList',
	paymentDetails = 'PaymentDetails',
	cashBalanceList = 'CashBalanceList',
}

export function paymentRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'all',
			name: PaymentRouteName.allPaymentList,
			component: () => import('../../views/payment/AllPayments.vue'),
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('allPayments')],
				caslSubject: 'payments.all_payment',
				caslAction: 'view',
				maskFeature: ['payments'],
			},
		},
		{
			path: 'new',
			name: PaymentRouteName.AddManualPayment,
			component: () => import('../../views/payment/AddManualPayment.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('allPayments'),
					breadcrumbs.get('newManualPayment'),
				],
				caslSubject: 'payments.all_payment',
				caslAction: 'manage',
				maskFeature: ['payments'],
			},
		},
		{
			path: 'transactions',
			name: PaymentRouteName.allTransactionList,
			component: () => import('../../views/payment/AllTransactions.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('allTransactions'),
				],
				caslSubject: 'payments.all_transactions',
				caslAction: 'view',
				maskFeature: ['payments'],
			},
		},
		{
			path: 'details/:id',
			name: PaymentRouteName.paymentDetails,
			component: () => import('../../views/payment/PaymentDetails.vue'),
			props: { online: null },
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('allPayments'),
					breadcrumbs.get('paymentDetails'),
				],
				dynamicFrom: 1,
			},
		},
		{
			path: 'cash-balance',
			name: PaymentRouteName.cashBalanceList,
			component: () => import('../../views/payment/CashBalance.vue'),
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('cashBalance')],
				caslSubject: 'payments.cash_balance',
				caslAction: 'view',
				maskFeature: ['payments'],
			},
		},
	];
}
